import { HistoryUpdatesItemType } from 'src/components/History/types';

export type EditKeysType =
    | 'ACTIVE'
    | 'IS_DELETED'
    | 'PHOTO_HASH'
    | 'FILES'
    | 'PRODUCT_TYPE'
    | 'SKU'
    | 'NAME'
    | 'DESCRIPTION'
    | 'HS_CODE'
    | 'BATTERY_TYPE'
    | 'INSERT_TYPE'
    | 'INSERT_BY_ORDER_TYPE'
    | 'INSERT_PRICE_FROM'
    | 'INSERT_PRICE_TO'
    | 'PRODUCT_INSERT_COUNTRIES'
    | 'AGECHECK'
    | 'QUANTITY_CONVERSION'
    | 'GLOBAL_PRODUCT'
    | 'SCAN_IMEI_SN_TYPE'
    | 'SN_REGEX'
    | 'ROP'
    | 'EXPIRATION_DAYS'
    | 'EAN'
    | 'EXP_METHOD'
    | 'WIDTH'
    | 'HEIGHT'
    | 'LENGTH'
    | 'WEIGHT'
    | 'PRICE'
    | 'UNIT_PRICE'
    | 'CUSTOM_FIELD_1'
    | 'CUSTOM_FIELD_2'
    | 'CUSTOM_FIELD_3'
    | 'ORIGIN_COUNTRY'
    | 'PRODUCT_RELATIONS_2'
    | 'PRODUCT_SET'
    | 'EANS';

export const EDIT_KEYS = [
    'ACTIVE',
    'IS_DELETED',
    'PHOTO_HASH',
    'FILES',
    'PRODUCT_TYPE',
    'SKU',
    'NAME',
    'DESCRIPTION',
    'HS_CODE',
    'BATTERY_TYPE',
    'INSERT_TYPE',
    'INSERT_BY_ORDER_TYPE',
    'INSERT_PRICE_FROM',
    'INSERT_PRICE_TO',
    'PRODUCT_INSERT_COUNTRIES',
    'AGECHECK',
    'QUANTITY_CONVERSION',
    'GLOBAL_PRODUCT',
    'SCAN_IMEI_SN_TYPE',
    'SN_REGEX',
    'ROP',
    'EXPIRATION_DAYS',
    'EAN',
    'EXP_METHOD',
    'WIDTH',
    'HEIGHT',
    'LENGTH',
    'WEIGHT',
    'PRICE',
    'UNIT_PRICE',
    'CUSTOM_FIELD_1',
    'CUSTOM_FIELD_2',
    'CUSTOM_FIELD_3',
    'ORIGIN_COUNTRY',
    'PRODUCT_RELATIONS_2',
    'PRODUCT_SET',
    'EANS',
];

export type ProductRelationEditKeysType = 'SKU' | 'TYPE';

export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'PRODUCT_TYPE', translateKey: 'productDetail.productType' },
    { key: 'SKU', translateKey: 'productDetail.SKU' },
    { key: 'NAME', translateKey: 'productDetail.name' },
    { key: 'DESCRIPTION', translateKey: 'productDetail.description' },
    { key: 'HS_CODE', translateKey: 'productDetail.hsCode' },
    { key: 'BATTERY_TYPE', translateKey: 'productDetail.batteryType' },
    { key: 'INSERT_TYPE', translateKey: 'productDetail.inserType' },
    { key: 'INSERT_BY_ORDER_TYPE', translateKey: 'productDetail.insertByOrderType' },
    { key: 'INSERT_PRICE_FROM', translateKey: 'productDetail.insertPriceFrom', format: 'number' },
    { key: 'INSERT_PRICE_TO', translateKey: 'productDetail.insertPriceTo', format: 'number' },
    { key: 'AGECHECK', translateKey: 'productDetail.agecheck' },
    { key: 'QUANTITY_CONVERSION', translateKey: 'productDetail.quantityConversion', format: 'number' },
    { key: 'GLOBAL_PRODUCT', translateKey: 'productDetail.globalProduct' },
    { key: 'SCAN_IMEI_SN_TYPE', translateKey: 'productDetail.scanSerialNumber' },
    { key: 'SN_REGEX', translateKey: 'productDetail.snRegex' },
    { key: 'ROP', translateKey: 'productDetail.ROP', format: 'number' },
    { key: 'EAN', translateKey: 'productDetail.EAN' },
    { key: 'EAN_LOCKED_BY_DCIX', translateKey: 'productDetail.eanLockedByDcix' },
    { key: 'EXP_METHOD', translateKey: 'productDetail.expMethod' },
    { key: 'WIDTH', translateKey: 'productDetail.width', format: 'number' },
    { key: 'HEIGHT', translateKey: 'productDetail.height', format: 'number' },
    { key: 'LENGTH', translateKey: 'productDetail.length', format: 'number' },
    { key: 'WEIGHT', translateKey: 'productDetail.weight', format: 'number' },
    { key: 'PRICE', translateKey: 'productDetail.price', format: 'number' },
    { key: 'UNIT_PRICE', translateKey: 'productDetail.unitPrice' },
    { key: 'CUSTOM_FIELD_1', translateKey: 'productDetail.customField1' },
    { key: 'CUSTOM_FIELD_2', translateKey: 'productDetail.customField2' },
    { key: 'CUSTOM_FIELD_3', translateKey: 'productDetail.customField3' },
    { key: 'ORIGIN_COUNTRY', translateKey: 'productDetail.originCountry' },
    { key: 'ACTIVE', translateKey: 'productDetail.active' },
    { key: 'IS_DELETED', translateKey: 'productDetail.isDeleted' },
    { key: 'DELETED_AT', translateKey: 'products.table.deletedAt', format: 'date' },
    { key: 'SOURCE_SYS', translateKey: 'productDetail.sourceSys' },
    { key: 'EXPIRATION_DAYS', translateKey: 'productDetail.EXPIRATION_DAYS', format: 'number' },
    { key: 'STOCK_MU_CODE', translateKey: 'productDetail.stockMuCode' },
    { key: 'PACKING_TYPE', translateKey: 'productDetail.packingType' },
    { key: 'INSERT_TO_PRODUCT_ID', translateKey: 'productDetail.insertToProductId', format: 'number' },
    { key: 'UPC', translateKey: 'productDetail.UPC' },
    { key: 'MPN', translateKey: 'productDetail.MPN' },
    { key: 'ISBN', translateKey: 'productDetail.ISBN' },
    { key: 'NOTE', translateKey: 'productDetail.note' },
    { key: 'PACKAGING_MATERIAL_SLOTS', translateKey: 'productDetail.packagingMaterialSlots', format: 'number' },
    { key: 'ESHOP_STOCK', translateKey: 'productDetail.eshopStock' },
    { key: 'REF_ID', translateKey: 'productDetail.refId' },
    { key: 'GUID', translateKey: 'productDetail.guid' },
    { key: 'DIMENSIONS_CHANGED_AT', translateKey: 'products.table.dimensionsChangedAt', format: 'date' },
];

export const historyUpdatesSkladonUser: HistoryUpdatesItemType[] = [
    ...historyUpdates,
    { key: 'ID', translateKey: 'products.table.id', format: 'number' },
    { key: 'OWNER_ESHOP_KEY', translateKey: 'productDetail.ownerEshopKey' },
    { key: 'ALIAS', translateKey: 'productDetail.alias', format: 'number' },
    { key: 'DCIX_IMPORT', translateKey: 'productDetail.dcixImport', format: 'date' },
    { key: 'DCIX_PROVIDER_ID', translateKey: 'productDetail.dcixProviderId', format: 'number' },
    { key: 'LINKED_ESHOP', translateKey: 'productDetail.linkedEshop' },
    { key: 'ATTACHED_IDENTIFIER', translateKey: 'productDetail.attachedIdentifier' },
];

/** Keys never shown for CREATE history entries (still shown on EDIT). */
export const historyCreateHiddenKeys: string[] = ['OWNER_ESHOP_KEY', 'DCIX_IMPORT', 'DCIX_PROVIDER_ID'];

export const historyInsertCountriesUpdates: HistoryUpdatesItemType[] = [
    { key: 'COUNTRY', translateKey: 'productDetail.country' },
];

export const historyProductRelationsUpdates: HistoryUpdatesItemType[] = [
    { key: 'PRODUCT_1.SKU', translateKey: 'productDetail.productRelationstable.SKU' },
    { key: 'TYPE', translateKey: 'productDetail.productRelationstable.type' },
];

export const historyProductSetUpdates: HistoryUpdatesItemType[] = [
    { key: 'PRODUCT_SKU', translateKey: 'productDetail.productRelationstable.SKU' },
    { key: 'PRODUCT_COUNT', translateKey: 'productDetail.productRelationstable.Count', format: 'number' },
];

export const historyEansUpdates: HistoryUpdatesItemType[] = [
    { key: 'ean', translateKey: 'productDetail.history.ean' },
    { key: 'active', translateKey: 'productDetail.history.eanActive' },
];

export const historyProductFilesUpdates: HistoryUpdatesItemType[] = [
    { key: 'TYPE', translateKey: 'productDetail.attachmentsHistoryType' },
    { key: 'ORIGINAL_FILE_NAME', translateKey: 'productDetail.attachmentsHistoryFileName' },
    { key: 'DESCRIPTION', translateKey: 'file.description' },
];

export const STORAGE_KEY = 'productEditData';
